import { render, staticRenderFns } from "./PageDashboard.vue?vue&type=template&id=c63c5fd2&"
import script from "./PageDashboard.vue?vue&type=script&lang=js&"
export * from "./PageDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports